<div
  class="toolbar-container"
  layout="row"
  layout-align="center"
  [ngClass]="{ collapsed: collapsed }"
  flex
  >
  <div class="toolbar" layout="column" layout-align="space-between center">
    <div layout="column">
      <!-- Finder -->
      <a
        mat-icon-button
        (click)="toggleLayout()"
        *ngxPermissionsOnly="['CREDIT_READ_ALL']"
        [matTooltip]="'global.finder' | translate"
        matTooltipPosition="right"
        >
        <mat-icon>search</mat-icon>
      </a>

      <!-- Credit calculator -->
      <a
        mat-icon-button
        *ngxPermissionsOnly="['CREDIT_READ_ALL', 'PRODUCTPLAN_READ']"
        (click)="toggleProductCalculator()"
        [matTooltip]="'global.calculator' | translate"
        matTooltipPosition="right"
        >
        <mat-icon fontSet="fa-solid" fontIcon="fa-calculator"></mat-icon>
      </a>

      <!-- Currency Toggle -->
      <itfg-currency-toggle tooltipPosition="below"></itfg-currency-toggle>
    </div>

    <!-- itfg-navigation-menu -->
    @if (collapsed || !mode || mode === 'submenu') {
      <div
        class="navigation-links"
        [@toolbarCollapse]
        >
        <ng-content></ng-content>
      </div>
    }

    @if (!collapsed && mode === 'menu') {
      <div (click)="backArrowClicked()">
        <a mat-icon-button>
          <mat-icon>arrow_back</mat-icon>
        </a>
      </div>
    }

    <div layout="column">
      <!-- Call hub -->
      <button
        *ngxPermissionsOnly="['CALLS_READ']"
        mat-icon-button
        (click)="handleToggleLeftSideNav(DrawerModeType.CallHub, 'side')"
        [matTooltip]="
          socketService.initializingSocketConnection
            ? ('communication.calls' | translate)
            : !socketService.socketConnected
              ? 'Проблем с връзката. Моля, презаредете страницата.'
              : ('communication.calls' | translate)
        "
        matTooltipPosition="right"
        [@jiggle]="callNotificationAnimation"
        >
        <mat-icon
          aria-hidden="false"
          fontSet="material-symbols-outlined"
          [matBadge]="
            !socketService.socketConnected &&
            !socketService.initializingSocketConnection
              ? '!'
              : hasCallNotifications
                ? '&#8203;'
                : ''
          "
          [matBadgeHidden]="
            (socketService.socketConnected ||
              socketService.initializingSocketConnection) &&
            !hasCallNotifications
          "
          matBadgePosition="after"
          matBadgeSize="small"
          [matBadgeColor]="'warn'"
          >deskphone</mat-icon
          >
        </button>

        <!-- Notifications -->
        <itfg-notifications-button></itfg-notifications-button>

        <!-- Profile / Logout -->
        <a
          mat-icon-button
          [matMenuTriggerFor]="profileMenu"
          [matTooltip]="sessionService.currentlyLoggedOperator.email"
          matTooltipPosition="right"
          >
          <mat-icon
            aria-hidden="false"
            matBadge="1"
            matBadgeColor="warn"
            matBadgeSize="small"
          [matBadgeHidden]="
            !sessionService?.currentlyLoggedOperator?.showPasswordExpiryReminder
          "
            >person</mat-icon
            >
          </a>

          <!-- Profile Menu -->
          <mat-menu #profileMenu="matMenu" [overlapTrigger]="false">
            <button
              mat-menu-item
              (click)="swichLanguage(getOppositeLanguage())"
              [matTooltip]="'global.language' | translate"
              matTooltipPosition="right"
              >
              <mat-icon>public</mat-icon>

              <span
            [translate]="
              currentLanguage === 'bg' ? 'global.bulgarian' : 'global.english'
            "
              ></span>
            </button>

            <button mat-menu-item [routerLink]="['/me', 'details']">
              <mat-icon
                aria-hidden="false"
                matBadge="1"
                matBadgeColor="warn"
                matBadgeSize="small"
            [matBadgeHidden]="
              !sessionService?.currentlyLoggedOperator
                ?.showPasswordExpiryReminder
            "
                >info</mat-icon
                >
                <span [translate]="'global.profile'">Profile</span>
              </button>

              <button mat-menu-item (click)="logout()">
                <mat-icon>exit_to_app</mat-icon>
                <span [translate]="'global.logout'">Logout</span>
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
